import { faSort, faSortUp, faSortDown } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface SortConfig {
    key: string;
    direction: 'asc' | 'desc';
}

export const getSortIcon = (key: string, sortedBy: SortConfig | null): IconDefinition => {
    if (sortedBy?.key !== key) return faSort;
    return sortedBy.direction === 'asc' ? faSortUp : faSortDown;
};

export const handleSort = (key: string, currentSort: SortConfig | null): SortConfig => {
    if (currentSort?.key === key) {
        return { key, direction: currentSort.direction === 'asc' ? 'desc' : 'asc' };
    }
    return { key, direction: 'asc' };
};

export const sortItems = <T extends Record<string, any>>(
    items: T[],
    sortConfig: SortConfig | null,
    key: string,
): T[] => {
    if (!items) return [];
    if (!sortConfig) return items;

    return [...items].sort((a, b) => {
        let aValue = a[sortConfig.key] || '';
        let bValue = b[sortConfig.key] || '';

        // Handle object values (like when the value is an object with a name property)
        if (typeof aValue === 'object') aValue = a?.name;
        if (typeof bValue === 'object') bValue = b?.name;

        if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });
};
